import React from 'react';
import PropTypes from 'prop-types';
import Select from '@lwt-helix/select';
import { Label } from '@lwt-helix/controls';
import { terms, viewOptions, showOptions } from '../../constants/savedAgents';
import { popoverIds } from '../savedAgents/helpers/index'
import { useSavedAgentsStore, useSearchStore } from '../../../store/store';
import { responseKeys } from '../../../constants/service';

const Display = ({
    handleShowHideChange,
    selectedAgentsView,
    togglePopover
}) => {

    const {
        setSummaryPinnedData,
    } = useSearchStore(state => ({
        setSummaryPinnedData: state.setSummaryPinnedData
    }));

    const {
        selectedView,
        setSelectedView,
     } = useSavedAgentsStore(state =>({
        selectedView: state.selectedView,
        setSelectedView: state.setSelectedView,
    }));

    const handleAgentsViewChange = (view, dataLwtId) => {
        setSelectedView(view);
        setSummaryPinnedData(view.value, responseKeys.recruitingSoldTotals);
        togglePopover(view, dataLwtId);
    };

    const handleAgentsShowChange = (show) => {
        handleShowHideChange(show.value);
        togglePopover();
    };

    return (
        <div className='py-2'>
            <Label
                dataLwtId='select-agents-view-label'
                for='select-agents-view'
                className='mb-1 helix-heading text-capitalize'
            >
                {terms.view}
            </Label>
            <Select
                id='select-agents-view'
                dataLwtId='select-agents-view'
                className='mb-2'
                isClearable={false}
                options={viewOptions}
                defaultValue={selectedView}
                matchFrom='start'
                value={selectedView}
                onChange={(view) => handleAgentsViewChange(view, popoverIds.display)}
            />

            <Label
                dataLwtId='select-agents-groups-label'
                for='select-agents-groups'
                className='mb-1 helix-heading text-capitalize'
            >
                {terms.agents}
            </Label>
            <Select
                id='select-agents-groups'
                dataLwtId='select-agents-groups'
                isClearable={false}
                options={showOptions}
                defaultValue={selectedAgentsView}
                matchFrom='start'
                value={showOptions.find(show => show.value === selectedAgentsView)}
                onChange={(view) => handleAgentsShowChange(view)}
            />
        </div>
    )
};

Display.propTypes = {
    handleShowHideChange: PropTypes.func.isRequired,
    selectedAgentsView: PropTypes.string.isRequired,
    togglePopover: PropTypes.func.isRequired,
};

export default Display;
